var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclipAttechmentTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40137 8.59938L8.57209 3.42866C10.1098 1.89097 12.6029 1.89097 14.1406 3.42866C15.6783 4.96635 15.6781 7.45957 14.1404 8.99726L8.17419 14.9635C7.14907 15.9886 5.48729 15.9885 4.46217 14.9633C3.43704 13.9382 3.43679 12.2763 4.46191 11.2512L10.4281 5.28498C10.9407 4.77242 11.7722 4.77242 12.2847 5.28498C12.7973 5.79754 12.7969 6.62837 12.2844 7.14094L7.11365 12.3117",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclipAttechmentTilt);
export default __webpack_public_path__ + "static/media/Paperclip_Attechment_Tilt.1c4697ea5a87bf48d7d700048d7a9ee1.svg";
export { ForwardRef as ReactComponent };